import { BILLING_FEATURES } from './billing';

import actions from '@/actions';

export const IMAGES_PER_PAGE = 25;

export const BULK_DOWNLOAD_LIMIT = 25;

export const THUMBNAIL_SIZE = 178;

export const MEDIA_TYPE = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
};

export const ORDER_BY = {
  CONNECTED_LISTINGS: 'connected_listing_count',
  CREATED_AT: 'created_at',
};

export const STUDIO_ACTIONS = {
  [MEDIA_TYPE.PHOTOS]: actions.studio.photos,
  [MEDIA_TYPE.VIDEOS]: actions.studio.videos,
};

export const STUDIO_STORE_PATH = {
  [MEDIA_TYPE.PHOTOS]: ['studio', 'photos'],
  [MEDIA_TYPE.VIDEOS]: ['studio', 'videos'],
};

export const STUDIO_BILLING_FEATURE = {
  [MEDIA_TYPE.VIDEOS]: BILLING_FEATURES.STUDIO_VIDEO_LIBRARY,
};
